import { z } from "zod";

export const createInstantNotificationSchema = () =>
  z.object({
    notifications: z.record(z.boolean()),
  });

export type InstantNotificationFormValues = z.infer<
  ReturnType<typeof createInstantNotificationSchema>
>;

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export const createPeriodicNotificationSchema = (t: TranslateFn) =>
  z.object({
    interval: z
      .number()
      .int()
      .nonnegative(
        t("common.invalidValue", {
          defaultValue: "Please select a valid interval.",
        }),
      ),
    limitSpacesMode: z
      .number()
      .int()
      .nonnegative(
        t("common.invalidValue", {
          defaultValue: "Please select a valid option.",
        }),
      ),
    limitSpaces: z.array(z.string()),
    activities: z.array(z.string()),
  });

export type PeriodicNotificationFormValues = z.infer<
  ReturnType<typeof createPeriodicNotificationSchema>
>;
